

const EventType = {
    Intervento: "Intervento",
    Assenza: "Assenza",
  };

  export default EventType;